module.exports = __webpack_public_path__ + "img/img_plan_hover.22fab5c8.svg";